import React, { ReactNode } from 'react';
import { ColDef, IServerSideGetRowsRequest } from '@ag-grid-community/core';

import { IDataQuery, IDataQueryResponse } from './data-query';

interface IProps {
  children: ReactNode | ReactNode[];
  columnTypes: { [p: string]: ColDef };
  getData: (source: string, request: IServerSideGetRowsRequest) => Promise<IDataQueryResponse>;
  getCsvFile?: (source: string, dataQuery: IDataQuery) => Promise<void>;
  getXlsxFile?: (source: string, dataQuery: IDataQuery) => Promise<void>;
  labelsNamespace?: string;
}

const defaultLabelsNamespace = 'agGrid';
export const DataTableProvider = React.createContext({
  columnTypes: {},
  getData: null,
  getCsvFile: null,
  getXlsxFile: null,
  labelsNamespace: defaultLabelsNamespace,
} as Partial<IProps>);

function DataTableProviderElement({
  children,
  columnTypes,
  getData,
  getCsvFile,
  getXlsxFile,
  labelsNamespace = defaultLabelsNamespace,
}: IProps) {
  return (
    <DataTableProvider.Provider value={{ columnTypes, getData, getCsvFile, getXlsxFile, labelsNamespace }}>
      {children}
    </DataTableProvider.Provider>
  );
}

export default DataTableProviderElement;
